// extracted by mini-css-extract-plugin
export default {"container":"form-row_container__PnER2","truncate-table":"form-row_truncate-table__U13kq","table-text-faded":"form-row_table-text-faded__9LiLt"};
    if(module.hot) {
      // 1793877086004
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  